import React, { forwardRef } from 'react';
import classNames from 'classnames';
import useEpisodePlayersContext from '../../../hooks/useEpisodePlayersContext';
import usePlayersContext from '../hooks/usePlayersContext';

const ProgressBar = forwardRef(({ buttonDisabled, currentTime, handleClick, setIsPlaying, setCurrentTime }, ref) => {
    const { activeEpisodeIndex } = useEpisodePlayersContext();
    const { episodeIndex } = usePlayersContext();
    const { current } = ref;

    const handleSeek = (e) => {
        const time = parseFloat(e.target.value);
        current.currentTime = time;
        if (current.currentTime < current.duration && current.paused) {
            if (activeEpisodeIndex !== episodeIndex) {
                return;
            }
            handleClick();
            setIsPlaying(true);
            current.play();
        }
        setCurrentTime(time);
    };

    const sliderClass = classNames('player-app__slider', {
        'episode-player-disabled': buttonDisabled(),
        'episode-player-enabled': !buttonDisabled(),
    });

    // const calculateProgressWidth = () => {
    //     const { currentTime, duration } = current;
    //     return `${(currentTime * 100) / duration}%`;
    // };

    const calculateProgressWidth = () => {
        if (!current) {
            return `0%`;
        }
        const { currentTime, duration } = current;
        const progress = (currentTime * 100) / duration;
        return `${Math.floor(progress * 100) / 100}%`;
    };

    return (
        <div className={sliderClass}>
            <span style={{ width: calculateProgressWidth() }} />
            <input
                type="range"
                min="0"
                max={isNaN(current?.duration) ? 0 : current.duration}
                step="0.0001"
                value={currentTime}
                onChange={handleSeek}
                disabled={buttonDisabled()}
            />
        </div>
    );
});

export default ProgressBar;
